/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CriteriaCategory } from './CriteriaCategory';
import {
    CriteriaCategoryFromJSON,
    CriteriaCategoryFromJSONTyped,
    CriteriaCategoryToJSON,
} from './CriteriaCategory';

/**
 * 
 * @export
 * @interface FindAllCriteriaCategories200Response
 */
export interface FindAllCriteriaCategories200Response {
    /**
     * 
     * @type {Array<CriteriaCategory>}
     * @memberof FindAllCriteriaCategories200Response
     */
    data?: Array<CriteriaCategory>;
}

/**
 * Check if a given object implements the FindAllCriteriaCategories200Response interface.
 */
export function instanceOfFindAllCriteriaCategories200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllCriteriaCategories200ResponseFromJSON(json: any): FindAllCriteriaCategories200Response {
    return FindAllCriteriaCategories200ResponseFromJSONTyped(json, false);
}

export function FindAllCriteriaCategories200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCriteriaCategories200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(CriteriaCategoryFromJSON)),
    };
}

export function FindAllCriteriaCategories200ResponseToJSON(value?: FindAllCriteriaCategories200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(CriteriaCategoryToJSON)),
    };
}

